import _ from 'lodash';            
import * as Enumerable from "linq";         
import Big from "big.js"           
                                 
import { Observable, Subject, forkJoin, combineLatest, merg  } from 'rxjs' 
import { map,mapTo,catchError,debounceTime,distinctUntilChanged } from 'rxjs/operators';                                 
                                        
import clfStage from "./clf.js";                                
import daily from "./daily";

export default {

    namespaced: true,    
    
    modules: {
        "clf" : clfStage,
        'daily': daily,
    },

    state: {
        
        mainSearchData : {},
        currentDcInfo : {},
        similarRangeForm :{
            wbtRange : 1,
            itLoadRateRange : 2
        },
        
        systemPUETotalDataCurrentPeriod : [],
        manualPUETotalDataCurrentPeriod : [],
        
        systemPUETotalDataLastPeriod : [],
        manualPUETotalDataLastPeriod : [],
        
        
        roomTotalReadingTP : new Big( 0 ),
        roomTotalReadingLP : new Big( 0 ),
        
        coolingTotalReadingTP : new Big( 0 ),
        coolingTotalReadingLP : new Big( 0 ),
        
        systemPUEHourlyDataTP : [],
        systemPUEHourlyDataLP : [],
        
        //本周平均工况相似值
        similarHistoryTS : [],
        //和本周每一小时工况相似的集合
        allSimilarHistory : [],
    },

    getters: {
       
        mainSearchData(state) {
            return state.mainSearchData;
        },
        
        currentDcInfo(state) {
            return state.currentDcInfo;
        },
        
        similarRangeForm( state ){
            return state.similarRangeForm;
        },
        
        systemPUETotalDataCurrentPeriod(state) {
            return state.systemPUETotalDataCurrentPeriod;
        },

        manualPUETotalDataCurrentPeriod(state) {
            return state.manualPUETotalDataCurrentPeriod;
        },

        systemPUETotalDataLastPeriod(state) {
            return state.systemPUETotalDataLastPeriod;
        },

        manualPUETotalDataLastPeriod(state) {
            return state.manualPUETotalDataLastPeriod;
        },
        
        roomTotalReadingTP(state) {
            return state.roomTotalReadingTP;
        },
        
        roomTotalReadingLP(state) {
            return state.roomTotalReadingLP;
        },

        coolingTotalReadingTP(state) {
            return state.coolingTotalReadingTP;
        },
        coolingTotalReadingLP(state) {
            return state.coolingTotalReadingLP;
        },
        
        systemPUEHourlyDataTP(state) {
            return state.systemPUEHourlyDataTP;
        },
        systemPUEHourlyDataLP(state) {
            return state.systemPUEHourlyDataLP;
        },
        
        similarHistoryTS(state) {
            return state.similarHistoryTS;
        },
        
        allSimilarHistory(state) {
            return state.allSimilarHistory;
        },
    },

    mutations: {
        
        changeMainSearchData(state, payload){
            
            state.mainSearchData = JSON.parse( JSON.stringify(payload) );
        },
        
        changeCurrentDcInfo(state, payload){
            state.currentDcInfo = JSON.parse( JSON.stringify(payload) );
        },
        
        changeSimilarRangeForm( state, payload){
             state.similarRangeForm = payload;
        },
        
        changeSystemPUETotalDataCurrentPeriod(state, payload) {
            
            const store = this;
            
            state.systemPUETotalDataCurrentPeriod = payload;
            
            store.dispatch('pue/systemPUETotalDataCurrentPeriodChangeAfter');
        },

        changeManualPUETotalDataCurrentPeriod(state, payload) {
            state.manualPUETotalDataCurrentPeriod = payload;
        },

        changeSystemPUETotalDataLastPeriod(state, payload) {
            
            const store = this;
            
            state.systemPUETotalDataLastPeriod = payload;
            
            store.dispatch('pue/systemPUETotalDataLastPeriodChangeAfter');
        },

        changeManualPUETotalDataLastPeriod(state, payload) {
            state.manualPUETotalDataLastPeriod = payload;
        },
        
        
        changeCoolingTotalReadingTP(state, payload) {
            state.coolingTotalReadingTP = payload;
        },
        
        changeCoolingTotalReadingLP(state, payload) {
            state.coolingTotalReadingLP = payload;
        },

        changeRoomTotalReadingTP(state, payload) {
            state.roomTotalReadingTP = payload;
        },
        
        changeRoomTotalReadingLP(state, payload) {
            state.roomTotalReadingLP = payload;
        },
        
        
        changeSystemPUEHourlyDataTP(state, payload) {
             state.systemPUEHourlyDataTP = payload;
        },
        changeSystemPUEHourlyDataLP(state, payload) {
             state.systemPUEHourlyDataLP = payload;
        },
        
        changeSimilarHistoryTS(state, payload) {
                    
             Enumerable.from( payload )
             .forEach( 
                 (item)=>{
                     let clf  = new Big("0");
                     let cold = new Big("0"); 
                     let recordRoom = new Big( _.get( item, "recordRoomAmount", 0 ) );   
             
                     let coldSource   = new Big( _.get( item, "coldSourceAmount"   , 0 ) );   
                     let coldTerminal = new Big( _.get( item, "coldTerminalAmount" , 0 ) );  
                     
                     cold = coldSource.plus( coldTerminal  );
                     item.cold = cold.toFixed(2);
             
                     if( recordRoom > 0 ) {
                         clf = cold.div( recordRoom );
                         item.clf = clf.toFixed(2);
                     }
                 }
             );
            
             state.similarHistoryTS = payload;
        },
        
        changeAllSimilarHistory(state, payload) {
            state.allSimilarHistory = payload;
        },
    },  
    actions: {
        
        systemPUETotalDataCurrentPeriodChangeAfter( { commit, state } ){
            
            const store = this;
            
            let recordRoom = _.get( state, "systemPUETotalDataCurrentPeriod.recordRoom", new Big( "0" ) );   
            
            let coldSource = _.get( state, "systemPUETotalDataCurrentPeriod.coldSource", new Big( "0" ) );   
            let coldTerminal =  _.get( state, "systemPUETotalDataCurrentPeriod.coldTerminal", new Big( "0" ) );  
            
            let cof = new Big( "0" );

            store.commit('pue/changeRoomTotalReadingTP'    , new Big( recordRoom.toFixed(2) ) );
            store.commit('pue/changeCoolingTotalReadingTP' , new Big( ( coldSource.plus( coldTerminal  ) ).toFixed(2) ) );
            
            if( recordRoom == 0 ) {
                store.commit('pue/changeClfTotalReadingTP' , "0" );
            }else{
                let clfReading = ( coldSource.plus( coldTerminal  ) ).div( recordRoom );
                store.commit('pue/changeClfTotalReadingTP' , clfReading.toFixed(2) );
            }
            
        },
        
        systemPUETotalDataLastPeriodChangeAfter( { commit, state } ){
            
            const store = this;
            
            let recordRoom   = _.get( state, "systemPUETotalDataLastPeriod.recordRoom"  , new Big( "0" ) );   
            let coldSource   = _.get( state, "systemPUETotalDataLastPeriod.coldSource"  , new Big( "0" ) );   
            let coldTerminal = _.get( state, "systemPUETotalDataLastPeriod.coldTerminal", new Big( "0" ) );  
            
            let cof = new Big( "0" );

            store.commit('pue/changeRoomTotalReadingLP'    , new Big( recordRoom.toFixed(2) ) );
            store.commit('pue/changeCoolingTotalReadingLP' , new Big( ( coldSource.plus( coldTerminal  ) ).toFixed(2) ) );
            
            if( recordRoom == 0 ) {
                store.commit('pue/changeClfTotalReadingLP' , "0" );
            }else{
                let clfReading = ( coldSource.plus( coldTerminal  ) ).div( recordRoom );
                store.commit('pue/changeClfTotalReadingLP' , clfReading.toFixed(2) );
            }
            
        }
    },
}